<as-split unit="pixel"
          direction="horizontal"
          gutterSize="7"
          gutterAriaLabel="divider"
          (dragEnd)="onSplitDragEnds($event)"
          #split="asSplit">
  <div *asSplitGutter
       class="custom-settings-area-gutter">
    <div asSplitGutterDragHandle
         class="custom-settings-area-gutter"></div>
  </div>
  <as-split-area [minSize]="splitterLeftContainerMinSize">
    <div class="ai-splitter-left-container">
      <ng-container *ngIf="activeProject; else noActiveProjectTemplate">
        <div class="rappider-ai-assistant">

          <div class="ai-assistant-scrolling-content">

            <rappider-chat-messages [messages]="displayedChannelMessages"
                                    [entityConfigs]="projectEntityConfigs"
                                    [channelId]="channelId"
                                    [senderAvatar]="senderAvatar"
                                    [receiverAvatar]="receiverAvatar"
                                    [isTyping]="aiCallInProgress"
                                    [sendButtonDisabled]="isTyping && !activeProject"
                                    [displaySkeleton]="!isMessagesLoaded"
                                    [fullScreenButtonVisibility]="isComponentInSidebar"
                                    [quickAnswerOptions]="quickAnswerOptions"
                                    [previousMessage]="previousMessage"
                                    [nextMessage]="nextMessage"
                                    (messageButtonClick)="onMessageButtonClick($event)"
                                    (fullScreenButtonClick)="onFullScreenButtonClick()"
                                    (quickAnswerButtonClick)="onQuickAnswerButtonClick($event)"></rappider-chat-messages>

          </div><!-- END OF SCROLLING AREA -->
          <!-- BEGIN OF ACTION CARDS  -->
          <section *ngIf="pageActionCardsVisibility"
                    class="action-cards-container container">
            <rappider-button class="action-cards-button"
                             [icon]="actionCardsButtonConfig"
                             [size]="actionCardsButtonConfig.size"
                             (click)="closePageActionCardsClick()"></rappider-button>
            <rappider-card-icon-title-description-list [items]="pageListOnModal"
                                                       [compactCards]="true"
                                                       (cardClick)="onActionButtonClick($event)"></rappider-card-icon-title-description-list>
          </section>
          <!-- END OF  -->
          <!-- ACTION BUTTONS - THIS IS NOT SCROLLING AREA -->
          <div #container class="action-buttons-container container">
            <!-- ai/assistant/private?viewMode=list -->
            <button nz-button
                    #button
                    nzType="default"
                    nzSize="small"
                    (click)="onEntitiesActionButtonClick()"
                    [nzTooltipTitle]="'Display Application Database & Tables'"
                    nz-tooltip
                    nzTooltipPlacement="top">
              <i class="fa-regular fa-database action-button-icon"></i>Database
            </button>
            <ng-container *ngFor="let page of visiblePages">

              <button nz-button
                      #button
                      nzType="default"
                      nzSize="small"
                      (click)="onActionButtonClick(page)"
                      [nzTooltipTitle]="'Display ' + page.name"
                      nz-tooltip
                      nzTooltipPlacement="top">
                <i class="{{page?.icon ?? 'fa-regular fa-window'}} action-button-icon"></i>
                {{page.title || page.name}}
              </button>
            </ng-container>
            <button *ngIf="moreButtonVisible"
                    nz-button
                    #button
                    nzType="default"
                    nzSize="small"
                    (click)="openPageActionCardsClick()"
                    [nzTooltipTitle]="'View Pages'"
                    nz-tooltip
                    nzTooltipPlacement="top">
              <i class="fa-regular fa-arrow-up-right"></i>More
            </button>
          </div>
          <!-- END OF ACTION BUTTONS -->
          <div class="rappider-ai-chat-input-container">
            <rappider-onboarding-widget [isDemoProject]="isDemoProject"
                                        [hasAskedSampleQuestion]="sampleChatQuestionAsked"
                                        [hasOwnProject]="projects?.length > 1"
                                        [tour]="tour"
                                        (demoQuestionAsked)="onDemoQuestionAsked($event)"
                                        (exploreClicked)="onExploreClicked()"
                                        (createProjectOnDemoClicked)="onCreateProjectClicked($event)"></rappider-onboarding-widget>
            <rappider-ai-active-item-selector *ngIf="entitySelectorVisibility"
                                              [entityData]="entityData"
                                              [entityDataListSelector]="parentEntityDataListSelector"
                                              [entityDataActiveItemSelector]="parentEntityDataActiveItemSelector"
                                              [activeEntityConfig]="activeEntityConfig"
                                              [cardListConfig]="activeEntityConfig?.config?.cardListConfig"
                                              (itemSelected)="onItemSelectedFromActiveItemSelector($event)"></rappider-ai-active-item-selector>
            <rappider-chat-input [features]="features"
                                 [activeFeature]="activeFeature"
                                 [entityCardListConfig]="activeEntityConfig?.config?.cardListConfig"
                                 [activeEntityItem]="activeEntityItem"
                                 [isAiInProgress]="aiCallInProgress"
                                 [joyrideStepOne]="joyrideStepOne"
                                 [joyrideStepTwo]="joyrideStepTwo"
                                 [isAiInProgress]="aiCallInProgress"
                                 [isTourDone]="isTourDone"
                                 [currentUserMessage]="displayedChannelMessages?.length ? displayedChannelMessages[0] : undefined"
                                 [previousMessage]="previousMessage"
                                 [nextMessage]="nextMessage"
                                 [dropdownColumns]="activeDataSources"
                                 [listGridConfig]="dataSourcesGridConfig"
                                 [buttonSelectionWrapper]="true"
                                 (goToPreviousMessages)="onGoToPreviousMessages($event)"
                                 (goToNextMessages)="onGoToNextMessages($event)"
                                 (isChatInputRendered)="onIsChatInputRendered($event)"
                                 (changeEntityButtonClicked)="onChangeEntityButtonClicked()"
                                 (featureSelected)="onFeatureSelected($event)"
                                 (displayDataSourcesButtonClicked)="onDisplayDataSourcesButtonClicked($event)"
                                 (nextClick)="onNextClick($event)"
                                 (doneClick)="onJoyrideDoneButtonClick()"
                                 (filteredDataSources)="onFilteredDataSources($event)"
                                 (messageSent)="sendMessageToRapider($event.message, $event.files)"></rappider-chat-input>
          </div>
        </div>
      </ng-container>

      <ng-template #noActiveProjectTemplate>
        <div class="rappider-ai-assistant no-active-project">
          <h5>No active project. Please select a project for ai assistant.</h5>
        </div>
      </ng-template>
    </div>
  </as-split-area>
  <as-split-area [size]="splitterRightContainerSize"
                 [visible]="displayDataSources || true">
    <!--  ai-splitter-toggle-button - Expand -->
    <div class="ai-splitter-right-container-toggle-button"
         nz-tooltip
         nzTooltipPlacement="right"
         [nzTooltipTitle]="splitterRightContainerSize > 0 ? 'Collapse Right Panel' : 'Expand Right Panel'"
         [ngClass]="{'collapsed': splitterRightContainerSize === 0}"
         (click)="onToggleSplitterRightContainer()">
      <a class="ai-splitter-toggle-button">
        <i [class]="splitterRightContainerSize > 0 ? 'fa-regular fa-angle-right ' : 'fa-regular fa-angle-left'"></i>
      </a>
    </div>
    <div class="ai-splitter-right-container">
      <router-outlet></router-outlet>
    </div>
  </as-split-area>
</as-split>
